import React, { useEffect, useState } from 'react'
import { APPLICATION_JSON, DEFAULT_IMAGE_140 } from '../../middleware/types';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { useDispatch } from 'react-redux';
import Helper from '../Helper';

const ProductRestrictModalMiniCart = ({ restrictedTitle, restrictedDiscontinueItem, restrictedItemGeo, restrictedItem, restrictedItemSpecialUser, handleGetCartList,
    handleCheckOut, hasScrollView, setHasScrollView, setCheckoutQuarantine, cartCount, setIsRestrictedModalShow, hideModal, guestUser }) => {
    const dispatch = useDispatch();
    function replaceImage(event) {
        event.target.src = DEFAULT_IMAGE_140;
    }
    useEffect(()=>{
        if(hideModal){
            document.getElementById('productRestrictionModal0CloseMini') && document.getElementById('productRestrictionModal0CloseMini').click();
        }
    },[hideModal])
    useEffect(() => {
        const modalElement = document.getElementById('productRestrictionModal0Mini');
        if (modalElement) {
          modalElement.addEventListener('hide.bs.modal', () => {
          setIsRestrictedModalShow(false);
          });
        }
      }, []);
    async function removeRestrictItem(removeType) {
        // setIsLoading(true)

        if (removeType === 'removeDiscontinuedItem') {
            var commerceIdDiscontinue = [];
            var commerceIdListDiscontinue = "";
            {
                restrictedDiscontinueItem && restrictedDiscontinueItem.map((value, key) => {
                    if (value && value.ciId) {
                        commerceIdDiscontinue.push(value.ciId)
                    }
                })
            }
            if (commerceIdDiscontinue.length > 0) {
                commerceIdListDiscontinue = commerceIdDiscontinue.join(",")
                if (cartCount != 0) {
                    if (guestUser) {
                        setCheckoutQuarantine('/checkout/login?qr=true')
                    } else {
                        setCheckoutQuarantine('/checkout/shipping?qr=true')
                    }
                }
            }
        }

        if (removeType === 'removeRestrictedUsersItem') {
            var commerceIdListSpecial = [];
            var commerceIdListJoinSpecial = "";
            {
                restrictedItemSpecialUser && restrictedItemSpecialUser.map((value, key) => {
                    if (value && value.ciId) {
                        commerceIdListSpecial.push(value.ciId)
                    }
                })
            }
            if (commerceIdListSpecial.length > 0) {
                commerceIdListJoinSpecial = commerceIdListSpecial.join(",")
                if (cartCount != 0) {
                    setCheckoutQuarantine('/checkout/shipping?qr=true')
                }
            }
        }


        if (removeType === 'removeGeoItem') {
            var commerceIdListGeo = [];
            var commerceIdListJoinGeo = "";
            {
                restrictedItemGeo && restrictedItemGeo.map((value, key) => {
                    if (value && value.ciId) {
                        commerceIdListGeo.push(value.ciId)
                    }
                })
            }
            if (commerceIdListGeo.length > 0) {
                commerceIdListJoinGeo = commerceIdListGeo.join(",")
                if (cartCount != 0) {
                    if (guestUser) {
                        setCheckoutQuarantine('/checkout/login?qr=true')
                    } else {
                        setCheckoutQuarantine('/checkout/shipping?qr=true')
                    }
                }
            }
        }

        if (removeType === 'removeSchoolItem') {
            var commerceIdListArray = [];
            var commerceIdListJoinString = "";
            {
                restrictedItem && restrictedItem.map((value, key) => {
                    if (value && value.ciId) {
                        commerceIdListArray.push(value.ciId)
                    }
                })
            }
            if (commerceIdListArray.length > 0) {
                commerceIdListJoinString = commerceIdListArray.join(",")
                if (cartCount != 0) {
                    setCheckoutQuarantine('/checkout/shipping?qr=true')
                }
            }
        }

        var actionUrl = "api/rest/cb/cart/remove-multiple-items";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({
            // urlParam: urlParam
            actionType: "removeMultipleItems",
            itemIds: commerceIdListDiscontinue ? commerceIdListDiscontinue : commerceIdListJoinSpecial ? commerceIdListJoinSpecial : commerceIdListJoinGeo ? commerceIdListJoinGeo : commerceIdListJoinString ? commerceIdListJoinString : ''
        }))
        if (res.result == "success") {
            dispatch(updateProfileDetailsAction(true,"cart"))
            handleGetCartList();           
            handleCheckOut()
            if(hideModal){
                document.getElementById('productRestrictionModal0CloseMini') && document.getElementById('productRestrictionModal0CloseMini').click();
            }
        } else {
            console.log("Error result ---->>>>removeRestrictItem")
        }

    }

    const viewRestrictedItem = (restrict) => {
        if (restrict && restrict.length > 0) {
            const firstItem = restrict[0].catalogRefId;
            document.getElementById(`cart-item-row_${firstItem}`).scrollIntoView({ behavior: 'smooth' });

            restrict.forEach((item) => {
                const viewItem = item && item.catalogRefId;
                const element = document.getElementById(`cart-item-row_${viewItem}`);
                if (element) {
                    document.getElementById('productRestrictionModal0CloseMini').click()
                    element.classList.add('restricted-item-row');
                    setHasScrollView(true);
                }
            });
        }

    }

    return (
        <>
            <div className="modal fade c-modal" id="productRestrictionModal0Mini" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                    <div className="modal-content">
                        <button type="button" id='productRestrictionModal0CloseMini' className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                        <div className="modal-body">
                            {/* <form method="POST" name="config_form_quarantine" action="" target="_top"> */}
                            <div className="container-fluid checkout-restrict-modal-body">

                            {restrictedDiscontinueItem && <div className="row mb-4">
                                    <div className="col-12">
                                        <h3 className="modal-title h3" id="defaultModalLabel">
                                            Discontinued Item Notice:
                                        </h3>
                                        <p className="modal-subheading">
                                            The following items have been discontinued, are no longer in stock, and will be removed from your shopping cart.
                                        </p>
                                    </div>
                                    <div className="col-12">

                                        {restrictedDiscontinueItem && restrictedDiscontinueItem.map((item) => {
                                            return (
                                                <>
                                                    <div className="d-flex checkout-restrict-item align-items-center mb-4">
                                                        <div className="col-auto mx-3">
                                                            <img onError={replaceImage} src={item.imageURL} title={item.displayName} />
                                                        </div>
                                                        <div className="col checkout-restrict-item-desc">
                                                            <p className="m-0">
                                                                <span className="cart-item-name"
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: item.displayName
                                                                    }}></span>
                                                                <span className="cart-item-number">#{item.catalogRefId}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        })}

                                        <div className="row mb-4">
                                            <div className="col-12 text-center text-md-start" >
                                                <a className="cart-primary-btn btn-primary" style={{ cursor: 'pointer' }} onClick={() => removeRestrictItem('removeDiscontinuedItem')}>
                                                    REMOVE ITEMS & CONTINUE
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>}

                                {restrictedItemSpecialUser ?
                                    <div className="row mb-4">
                                        <div className="col-12">
                                            <h3 className="modal-title h3" id="defaultModalLabel">
                                                Users Restriction:
                                            </h3>
                                            <p className="modal-subheading">
                                                The following item(s) can only be purchased by authorized users and will be removed from your shopping cart.
                                            </p>
                                        </div>
                                        <div className="col-12">

                                            {restrictedItemSpecialUser && restrictedItemSpecialUser.map((item) => {
                                                return (
                                                    <>
                                                        <div className="d-flex checkout-restrict-item align-items-center mb-4">
                                                            <div className="col-auto mx-3">
                                                                <img onError={replaceImage} src={item.imageURL} title={item.displayName} />
                                                            </div>
                                                            <div className="col checkout-restrict-item-desc">
                                                                <p className="m-0">
                                                                    <span className="cart-item-name"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: item.displayName
                                                                        }}></span>
                                                                    <span className="cart-item-number">#{item.catalogRefId}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })}

                                            <div className="row mb-4">
                                                <div className="col-12 text-center text-md-start" >
                                                    <a className="cart-primary-btn btn-primary" style={{cursor : 'pointer'}} onClick={() => removeRestrictItem('removeRestrictedUsersItem')}>
                                                        REMOVE ITEMS & CONTINUE
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : ''}

                                {restrictedItemGeo ?
                                    <div className="row mb-4">
                                        <div className="col-12">
                                            <h3 className="modal-title h3" id="defaultModalLabel">
                                                Geographic Item Notice:
                                            </h3>
                                            <p className="modal-subheading">
                                                The following items cannot be purchased in your area due to local regulations and will be removed from your shopping cart.
                                            </p>
                                        </div>
                                        <div className="col-12">

                                            {restrictedItemGeo && restrictedItemGeo.map((item) => {
                                                return (
                                                    <>
                                                        <div className="d-flex checkout-restrict-item align-items-center mb-4">
                                                            <div className="col-auto mx-3">
                                                                <img onError={replaceImage} src={item.imageURL} title={item.displayName} />
                                                            </div>
                                                            <div className="col checkout-restrict-item-desc">
                                                                <p className="m-0">
                                                                    <span className="cart-item-name"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: item.displayName
                                                                        }}></span>
                                                                    <span className="cart-item-number">#{item.catalogRefId}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })}

                                            <div className="row mb-4">
                                                <div className="col-12 text-center text-md-start" >
                                                    <a className="cart-primary-btn btn-primary" style={{cursor : 'pointer'}} onClick={() => removeRestrictItem('removeGeoItem')}>
                                                        REMOVE ITEMS & CONTINUE
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : ''}

                                {restrictedItem ?
                                    <div className="row mb-4">
                                        <div className="col-12">
                                            <h3 className="modal-title h3" id="defaultModalLabel">
                                                Restricted Item Notice:
                                            </h3>
                                            <p className="modal-subheading">
                                                The following items can only be purchased by authorized accounts and will be removed from your shopping cart.
                                            </p>
                                        </div>
                                        <div className="col-12">
                                            {restrictedItem && restrictedItem.map((item) => {
                                                return (
                                                    <>
                                                        <div className="d-flex checkout-restrict-item align-items-center mb-4">
                                                            <div className="col-auto mx-3">
                                                                <img onError={replaceImage} src={item.imageURL} title={item.displayName} />
                                                            </div>
                                                            <div className="col checkout-restrict-item-desc">
                                                                <p className="m-0">
                                                                    <span className="cart-item-name"
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: item.displayName
                                                                        }}></span>
                                                                    <span className="cart-item-number">#{item.catalogRefId}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            })}
                                            <div className="row mb-4 w-100 c-view-restrict">
                                                <div className="col-12 text-center text-md-start">
                                                    <a className="btn btn-primary mb-2 me-1"  style={{cursor : 'pointer'}} onClick={() => removeRestrictItem('removeSchoolItem')}>
                                                        REMOVE ITEMS & CONTINUE
                                                    </a>
                                                    <a className="btn btn-primary mb-2 modal-continue"  style={{cursor : 'pointer'}} onClick={() => viewRestrictedItem(restrictedItem)}>
                                                        GO TO CART & REVIEW
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : ""}
                            </div>
                            {/* </form> */}
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default ProductRestrictModalMiniCart